import {NgClass} from "@angular/common";
import {Component, EventEmitter, Input, Output} from '@angular/core';

import {NgbCollapse} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'nz-search-filter',
  standalone: true,
  imports: [
    NgClass,
    NgbCollapse
  ],
  templateUrl: './search-filter.component.html',
  styleUrl: './search-filter.component.scss'
})
export class SearchFilterComponent {
  @Input() activeFiltersCount: number = 0;
  @Input() isFiltersCollapsed: boolean = true;
  @Output() onClearFilters: EventEmitter<void> = new EventEmitter();
}
